import * as Constants from './Constants';

export const getCheckOutDetails = (data) => ({
  type: Constants.GET_CHECKOUT_DETAILS,
  data,
});
